<iframe
  [class.modal]="isModal()"
  [class.cockpit-content]="!isModal()"
  [src]="currentUrl | safe"
  title="Legal Documents"
>
</iframe>
